<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { FlowSelectPlanInboundWidgetQC } from '@/widgets/Flow'
  useApiRequestsAbort()
</script>

<template>
  <FlowSelectPlanInboundWidgetQC />
</template>
